<template lang="">
  <b-button
    variant="flat-info"
    style="padding: 4px"
    :disabled="disabledCopy"
    @click="onClickCopy"
  >
    <feather-icon
      class="cursor-pointer"
      icon="CopyIcon"
      size="16"
    />
  </b-button>
</template>
<script>
import { toRef } from '@vue/composition-api'
import { BButton } from 'bootstrap-vue'

import { useCopyText } from '@/@core/utils/utils'

export default {
  components: {
    BButton,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const textToCopy = toRef(props, 'text')
    const { copy, disabledCopy } = useCopyText()
    function onClickCopy() {
      copy(textToCopy.value)
    }
    return {
      onClickCopy,
      disabledCopy,
    }
  },
}
</script>
<style lang="">

</style>
